import { FilterType, type FilterDefinition, type FilterValues, type FilterWithSelection } from "@/services/filter";

/**
 * Merge filter definitions with current selection state for UI rendering.
 */
export function mergeFiltersWithSelection(definitions: FilterDefinition[], values: FilterValues): FilterWithSelection[] {
  return definitions.map((def) => {
    const val = values[def.slug];

    // Checkboxes always need an array selection — a single value in the URL (path segment with
    // one value, or a query string with only one occurrence of the key) arrives as a plain string,
    // which must still render as a checked checkbox rather than an empty selection.
    const selectedValue = def.type === FilterType.Checkboxes ? (val === undefined ? [] : Array.isArray(val) ? val : [val]) : Array.isArray(val) ? val : (val ?? null);

    // For range filters, extract _min/_max values from URL params
    if (def.type === FilterType.Range) {
      const minStr = values[`${def.slug}_min`];
      const maxStr = values[`${def.slug}_max`];
      const selectedMin = typeof minStr === "string" && minStr !== "" ? Number(minStr) : undefined;
      const selectedMax = typeof maxStr === "string" && maxStr !== "" ? Number(maxStr) : undefined;
      return { ...def, selectedValue, selectedMin, selectedMax };
    }

    return { ...def, selectedValue };
  });
}
